<pw-view-title>{{ viewModel?.position?.TEXT }}</pw-view-title>

<pw-view-actions>
  <button mat-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
</pw-view-actions>

<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    routerLink="/general/qr-code/{{ viewModel?.position?.OBJECT_ID }}">
    <span>QR-Code</span>
  </button>
</mat-menu>

<div class="p4m-grid-3-col">

  <mat-card *ngIf="viewModel">
    <mat-card-header>
      <mat-card-title
        >{{ 'general.infoPanels.position.projectDetails' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-nav-list>
        <mat-list-item *ngIf="viewModel.customer">
          <img matListItemIcon [src]="viewModel.customer?.ICON_URL" />
          <span matListItemLine style="word-wrap: anywhere; white-space: break-spaces">{{ viewModel.customer?.TEXT }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="viewModel.project">
          <img matListItemIcon [src]="viewModel.project?.ImCON_URL" />
          <span matListItemLine style="word-wrap: anywhere; white-space: break-spaces">{{ viewModel.project?.TEXT }}</span>
        </mat-list-item>
        <mat-list-item *ngIf="viewModel.part">
          <img matListItemIcon [src]="viewModel.part?.ICON_URL" />
          <span matListItemLine style="word-wrap: anywhere; white-space: break-spaces">{{ viewModel.part?.TEXT }}</span>
        </mat-list-item>
        <mat-list-item
          routerLink="/general/info-panels/pse/{{
            viewModel.rootPse.OBJECT_ID
          }}">
          <img matListItemIcon [src]="viewModel.rootPse?.ICON_URL" />
          <span matListItemLine style="word-wrap: anywhere; white-space: break-spaces">{{ viewModel.rootPse?.TEXT }}</span>
        </mat-list-item>
      </mat-nav-list>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="viewModel?.positions">
    <mat-card-header>
      <mat-card-title
        >{{ 'general.infoPanels.position.bom' | translate }}
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-nav-list *ngIf="viewModel.positions.length > 0">
        <mat-list-item
          *ngFor="let pos of viewModel.positions"
          routerLink="/general/info-panels/position/{{ pos.OBJECT_ID }}">
          <img matListItemIcon src="{{ pos.ICON_URL }}" />
          <span matListItemLine style="word-wrap: anywhere; white-space: break-spaces">{{ pos.TEXT }}</span>
        </mat-list-item>
      </mat-nav-list>

      <div *ngIf="viewModel.positions.length === 0">
        {{ 'general.infoPanels.position.noMorePositions' | translate }}.
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="viewModel?.tasks">
    <mat-card-header>
      <mat-card-title
        >{{ 'general.infoPanels.position.tasks' | translate }}
      </mat-card-title>
    </mat-card-header>

    <mat-card-content *ngIf="viewModel?.tasks.length > 0">
      <mat-nav-list>
        <mat-list-item
          *ngFor="let task of viewModel.tasks"
          routerLink="/general/info-panels/task/{{ task.OBJECT_ID }}">
          <img matListItemIcon src="{{ task.ICON_URL }}" />
          <span matListItemLine style="word-wrap: anywhere; white-space: break-spaces">{{ task.TEXT }}</span>
        </mat-list-item>
      </mat-nav-list>
    </mat-card-content>

    <mat-card-content *ngIf="viewModel?.tasks.length === 0">
      {{ 'general.infoPanels.position.noTasksFound' | translate }}
    </mat-card-content>
  </mat-card>

  <p4m-pos-params-info [pos]="viewModel?.position"></p4m-pos-params-info>

  <mat-card *ngIf="viewModel?.documents">
    <mat-card-header>
      <mat-card-title
        >{{ 'general.infoPanels.position.documents' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="viewModel.documents.length > 0">
      <app-document-list [documents]="viewModel?.documents"></app-document-list>
    </mat-card-content>
    <mat-card-content *ngIf="viewModel.documents.length === 0">
      {{ 'general.infoPanels.position.noDocumentsFound' | translate }}
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="viewModel?.clampings">
    <mat-card-header>
      <mat-card-title
        >{{ 'general.infoPanels.position.setups' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content
      *ngIf="viewModel?.clampings?.length > 0; else noClampings">
      <mat-nav-list>
        <mat-list-item
          *ngFor="let clamping of viewModel.clampings"
          (click)="redirect(clamping.OBJECT_ID)">
          <span matListItemLine style="word-wrap: anywhere; white-space: break-spaces">{{ clamping.TEXT }}</span>
        </mat-list-item>
      </mat-nav-list>
    </mat-card-content>
    <ng-template #noClampings>
      <mat-card-content
        >{{ 'general.infoPanels.position.noSetupsFound' | translate }}
      </mat-card-content>
    </ng-template>
  </mat-card>
</div>
